import styled from 'styled-components';

export const Wrapper = styled.div<{ $colorStart: string; $colorEnd: string; }>`
  background: ${({$colorStart, $colorEnd}) => `linear-gradient(270deg, ${$colorStart} -2.26%, ${$colorEnd} 100%)`};
  padding: 16px;
  border-radius: 8px;
	height: 100px;
	overflow: hidden;
	display: flex;
	align-items: center;

	@media (max-width: 764px) {
		height: auto;
		background: ${({$colorStart, $colorEnd}) => `linear-gradient(0deg, ${$colorStart} -2.26%, ${$colorEnd} 100%)`};
  }
`;

export const Info = styled.div`
  width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;

  @media (max-width: 764px) {
		flex-direction: column;
		text-align: center;
	}
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
	margin-bottom: 0;
  color: ${({ theme }) => theme.colors.text.alwaysWhite};
  line-height: 150%;

  @media (max-width: 764px) {
    font-size: 16px;
	}
`;

export const Image = styled.img`
	height: 100px;
`;
